module.exports = __webpack_public_path__ + "fonts/balanced-2m-ic.svg";